export default __webpack_public_path__ + "static/media/colorSensor@2x.3d6b0a6c.png";